module.exports = __webpack_public_path__ + "img/BLADE.aa769513.jpg";